import axios from "axios";
import API_V2_URL from "@/constants/API_V2_URL";

const NoticeService = {
  all({ page, limit, q, status, all }) {
    return axios.get(
      `${API_V2_URL()}/system/notices?page=${page}&status=${status}&limit=${limit}&q=${q}&all=${
        all ? "true" : "false"
      }`
    );
  },
  create(formData) {
    return axios.post(`${API_V2_URL()}/system/notices`, formData);
  },
  update(formData, id) {
    return axios.put(`${API_V2_URL()}/system/notices/${id}`, formData);
  },
  getUserNotices() {
    return axios.get(`${API_V2_URL()}/system/user_notices`);
  },
  markNoticeAsViewed(id) {
    return axios.put(`${API_V2_URL()}/system/user_notices/mark_as_viewed/${id}`);
  }
};

export default NoticeService;


// WEBPACK FOOTER //
// ./src/services/system/NoticeService.js